<template>
    <h2>Search</h2>
</template>

<script>
    export default {
        name: "AdminSearch"
    }
</script>

<style scoped>

</style>
